import { Component, OnInit } from '@angular/core';
import { NavController, NavParams,
         LoadingController, ModalController,
         AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

//types
import {LoginInfo,AddressItem,ValidateCheckoutVM} from '../model/types'

//service
import { AppSharedService  } from '../service/app_shared';

//page
import { ManageaddressPage } from '../manageaddress/manageaddress';
import { MenuPage } from '../menu/menu';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-address',
  templateUrl: 'address.html',
})
export class AddressPage implements OnInit {

 //class level variable
  LocationId :number;
  AddresList:AddressItem[];
  
  //constructor
  constructor(public navCtrl: NavController, 
              public loadingCtrl:LoadingController,
              public navParams: NavParams,
              public storage: Storage,
              public http: Http,
              public appSharedService:AppSharedService,
              public modalCtrl : ModalController,
              private https: HttpClient,
              public alertCtrl: AlertController,
              ) {

    this.initializeOnLoad();
    this.AddresList=[];
  }
  
  //initialize method
  ngOnInit(){

  }
  goToHome(){
    this.navCtrl.popToRoot();
    this.navCtrl.setRoot(MenuPage)
  }
  ionViewDidLoad() {
  }

  //get user info
  initializeOnLoad(){

    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {
      if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
               this.LocationId=userinfo.LocationId;
               this.getAddressDetails();
      }
    });
  }
  
  //modify address
  managethisAddress(curAddress: AddressItem){
    this.showManageAddressModal(curAddress);
  }

  //add new address
  addAddress(){
    let profileModal = this.modalCtrl.create(ManageaddressPage);
    profileModal.onDidDismiss(data => {    
      if(data!=undefined && data !=null && data.AddressId!=undefined && data.AddressId!=null){
        this.AddUpdateDeleteAddress(data);
      }
    });
    profileModal.present();
  }

  //manage address
  showManageAddressModal(curAddress:AddressItem){

    let datatosend={
      AddressId: curAddress.AddressId,ContactName:curAddress.ContactName,Contact:curAddress.Contact,LandMark:curAddress.LandMark,
      Street1:curAddress.Street1,Street2:curAddress.Street2,LocationId:curAddress.LocationId,IsDefault:curAddress.IsDefault
    };

    let profileModal = this.modalCtrl.create(ManageaddressPage, datatosend );
    
    profileModal.onDidDismiss(data => {    
      if(data!=undefined && data !=null && data.AddressId!=undefined && data.AddressId!=null){
        this.AddUpdateDeleteAddress(data);
      }
    });
    
    profileModal.present();
  }
 
// call database to add/update/delete address
 AddUpdateDeleteAddress(addressdata : AddressItem){

  if(addressdata.Type=="delete" || addressdata.Type=="update" || addressdata.Type=="add"){
      //create loader
      let loading = this.loadingCtrl.create({
        content: 'Please wait...'
      });

    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

    //initialize url
    var url= (this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlLastShippingAddress);
    url=url+"/"+addressdata.Type;

    // show loader
    loading.present();
    addressdata.LocationId=userinfo.LocationId;
    //create header
    let myheaders = new HttpHeaders();
    myheaders =myheaders.append('Content-Type', 'application/json');
    myheaders =myheaders.append('token', userinfo.Token);

    // do the service call
    this.https.post(url, addressdata, {headers:myheaders,observe: 'response'})
          .subscribe((res: HttpResponse<any>) => {   
            if(res.status==200 && res.statusText=="OK"){
              
              let message=this.appSharedService.getHttpResponseMessage(res,'Your delivery address changed successfully.');            
              //dismiss loader
              loading.dismiss();

              //show message
              this.alertCtrl.create({
                  title: 'Confirmation',
                  subTitle: message,
                  buttons: ['OK']
                }).present();
              
              //fetch latest
              this.getAddressDetails();
              
            }else if(res.status==204){       
              loading.dismiss();
              this.storage.clear();
              this.navCtrl.popToRoot();
              this.navCtrl.setRoot(LoginPage);
            }
              else{                        
                //dismiss loader
                loading.dismiss();
                
                let message=this.appSharedService.getHttpResponseMessage(res,'There is problem with adding address. please try after sometime!');            
                //display error message
                  this.alertCtrl.create({
                  title: 'Error',
                  subTitle: message,
                  buttons: ['OK']
                }).present();
              }
          });
    });
   }
 }
 // get address details
  getAddressDetails(){
    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

      if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
      
      //create loader
      let loading = this.loadingCtrl.create({
        content: 'Please wait...'
      });

      // create header
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', userinfo.Token);
      const options = new RequestOptions({headers: headers});
      
      //create url
      var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlLastShippingAddress);
     
    //display loader
    loading.present();

    // do the service call
     this.http.get(url,options )
         .subscribe((res: Response) => {   
              if(res.status==200){
                var respobj= JSON.parse(res.text()) as ValidateCheckoutVM;
                this.AddresList=respobj.addressList;
                loading.dismiss();
              }else if(res.status==204){        
                loading.dismiss();
                this.storage.clear();
                this.navCtrl.popToRoot();
                this.navCtrl.setRoot(LoginPage)
              }
              else
              {
                loading.dismiss();
              }
           });
          }
       }); 
  }
}



// WEBPACK FOOTER //
// ./src/pages/address/address.ts